import { memo, ReactNode } from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { LinkProps } from './interface';

interface Props extends LinkProps {
  children: ReactNode;
  isSelected?: boolean;
}

const WithLink = ({ href, children, className, isSelected }: Props) =>
  isSelected ? (
    <>{children}</>
  ) : (
    <RouterLink className={className} to={href}>
      {children}
    </RouterLink>
  );

export default memo(WithLink);
